interface User {
  email: string
  name: string
}

export const accountTeamMemberFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  AccountAccessLevel: 'accountAccessLevel',
  TeamMemberRole: 'teamMemberRole',
  User: {
    key: 'user',
    in: (teamMember) => ({
      email: teamMember.User?.Email,
      name: teamMember.User?.Name
    })
  },
  UserId: 'userId'
}

export interface AccountTeamMember {
  id: string
  accountAccessLevel: string
  teamMemberRole: string
  user: User
  userId?: string
}
